import Axios from 'axios'

import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';
export const SET_CATEGORIES = 'categories:getCategories'
export const SET_CATEGORIES_FETCHING = 'categories:getCategories:fetching'
export const SET_TRADE = 'trade:getTrade'

export type CATEGORIES_LIST_TYPE = {
  type: 'categories:getCategories',
  payload: { categories: Object[] }
}

export type TRADE_LIST_TYPE = {
  type: 'trade:getTrade',
  payload: { trade: Object[] }
}

export const setCategoryList = (categories: Object[]): CATEGORIES_LIST_TYPE => ({
  type: SET_CATEGORIES,
  payload: { categories }
})

export const setTradList = (trade: Object[]): TRADE_LIST_TYPE => ({
  type: SET_TRADE,
  payload: { trade }
})

export const fetchCategories = async () => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
            query {
              categories {
                      id
                      name
                  }
            }`
  }
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  const response = await Axios.post(apiUrl, query, CONTENT_TYPE).catch(() => {
    return null;
  });
  return response;
}

export const fetchCategoriesList = (dispatch: Function) => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  dispatch({
      type: SET_CATEGORIES_FETCHING,
      payload: true,
  })

  const query = {
    query: `
            query {
              categories {
                      id
                      name
                      description
                      hassubcategories
                      slug
                      sortOrder
                      hideTitleOnPosts
                      categories {
                         name
                         description
                         hassubcategories
                         slug
                      }
                      posts{
                        id
                        title
                        content
                        postDate
                        slug
                      }
                  }
            }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  Axios.post(apiUrl, query, CONTENT_TYPE)
    .then(function (response) {
      dispatch(setCategoryList(response.data.data.categories || []))
      dispatch({
        type: SET_CATEGORIES_FETCHING,
        payload: false,
      })
    })
    .catch(function (error) {
      console.log("error",error);
      dispatch({
       type: SET_CATEGORIES_FETCHING,
       payload: false,
      })
    });
}

export const fetchCategoryPosts = (categorySlug) => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
    const query = {
        query: `
            query {
              categories(where:{
                slug: "${categorySlug}"
              }) {
                id 
                name
                sortOrder
                hideTitleOnPosts
                posts {
                  id
                  title
                  content
                  shortcontent
                  postDate
                  slug
                }
              }
            }`
    }
  
    const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    return Axios.post(apiUrl, query, CONTENT_TYPE)
}

export const fetchPost = (postSlug) => {
    const apiUrl = getCookie('graphQLURL') || graphQLURL
    const token = getCookie('securityToken') || graphQLToken
    const query = {
        query: `
            query {
              posts(where:{
                slug: "${postSlug}"
              }) {
                id 
                title
                content
                trade {
                  tradeIdentifier
                }
                shortcontent
                postDate
              }
            }`
    }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    return Axios.post(apiUrl, query, CONTENT_TYPE)
}


export const fetchTradList = () => {
    const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
    const query = {
        query: `{
      portfolio {
        portfolioSnapshot {
          tradeID
          name
          openDate
          closedDate
          strategy
          symbols      
          profit
          transactions {
            tradeDate
            quantity
            symbol
            underlying
            assetType        
            expiration
            strike
            price
            transactionGroup        
          }
        }
      }
    }`
    }

    const CONTENT_TYPE = { 'Content-Type': 'application/json' }
    return Axios.post(apiUrl, query, CONTENT_TYPE)
}


// WEBPACK FOOTER //
// ./src/actions/categories/index.js